"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctionStageEnum = void 0;
const zod_1 = require("zod");
/**
 * WHERE A REQUEST IS in Request -> Verify -> Approve. Derived on the server from the row (status + whether it has been
 * verified), never stored, so it cannot disagree with the row it describes:
 *   AWAITING_VERIFICATION  entered, nobody has verified it yet
 *   AWAITING_APPROVAL      verified, waiting for an approver
 *   APPROVED / REJECTED    decided (a REJECTED row with no verifier was rejected at verification)
 *
 * Its own file because the payment and receipt response schemas both carry it and the combined workflow response imports
 * both of them — defining it in the combined file would be a circular import.
 */
exports.correctionStageEnum = zod_1.z.enum(['AWAITING_VERIFICATION', 'AWAITING_APPROVAL', 'APPROVED', 'REJECTED']);
//# sourceMappingURL=financial-correction-stage.response.js.map